var id = 1;
var Gradient = /** @class */ (function () {
    function Gradient(option) {
        this.isGradient = true;
        this.option = option;
        this.id = 'okee-render-gradient-' + id++;
    }
    Gradient.prototype.addColorStop = function (offset, color) {
        this.option.stops.push({ offset: offset, color: color });
    };
    return Gradient;
}());
export default Gradient;
